import React from 'react';
import './QuitusPage.scss';
import { Button, Container, Typography } from '@design-system';
import { HeaderToggle, QuitusCard } from '@components';
import { useQuitusPageVM } from './useQuitusPageVM';
import { BiPlus } from 'react-icons/bi';
import { QuitusSkeleton } from './QuitusSkeleton';

export const QuitusPage: React.FC = () => {
    const { waitingQuituses, validatedQuituses, isLoadingQuituses, navigate } = useQuitusPageVM();

    return (
        <div className="quitus-page">
            <HeaderToggle labels={['En cours', 'Traités']}>
                <Container className="waiting-quitus-container">
                    {isLoadingQuituses ? (
                        <QuitusSkeleton />
                    ) : (
                        <>
                            {waitingQuituses.length > 0 ? (
                                waitingQuituses.map((quitus) => <QuitusCard key={quitus.id} quitus={quitus} />)
                            ) : (
                                <Typography intrinsic="p" color="grey" defaultSpacing>
                                    Aucun quitus en cours
                                </Typography>
                            )}
                        </>
                    )}
                </Container>
                <Container className="validated-quitus-container">
                    {isLoadingQuituses ? (
                        <QuitusSkeleton />
                    ) : (
                        <>
                            {validatedQuituses.length > 0 ? (
                                validatedQuituses.map((quitus) => <QuitusCard key={quitus.id} quitus={quitus} />)
                            ) : (
                                <Typography intrinsic="p" color="grey" defaultSpacing>
                                    Aucun quitus traité
                                </Typography>
                            )}
                        </>
                    )}
                </Container>
            </HeaderToggle>

            <div className="floating-button">
                <Button
                    color="marine"
                    size="fullwidth"
                    icon={<BiPlus />}
                    iconColor="white"
                    iconPosition="forced-left"
                    iconSize={28}
                    onClick={() => navigate('/mes-chantiers/quitus/new')}
                >
                    <Typography intrinsic="h4">Nouveau quitus</Typography>
                </Button>
            </div>
        </div>
    );
};
